import React from 'react';
import './IconToggleGroup.css';

/**
 * IconToggleGroup — независимые icon-кнопки в виде toggle. В отличие от
 * сегментированного контрола (где сегменты в общей pill-обёртке с подсветкой
 * активного), каждая кнопка здесь самостоятельная и имеет собственный
 * border / background — нагляднее для бинарных выборов вроде
 * «вертикальный / горизонтальный формат», где иконка несёт основной
 * смысл.
 *
 * Используется в:
 *  - PrintControls → Orientation (RectangleHorizontal / RectangleVertical)
 *
 * @param {object} props
 * @param {string} props.value — текущее выбранное значение.
 * @param {(value: string) => void} props.onChange — handler смены.
 * @param {Array<{value, icon, ariaLabel?}>} props.options — варианты.
 *   `icon` — компонент из @phosphor-icons/react. `ariaLabel` — текст для
 *   screen-reader и `title` (native tooltip).
 * @param {string} [props.ariaLabel] — общий label для radiogroup.
 * @param {string} [props.className] — дополнительный CSS класс.
 */
export const IconToggleGroup = ({
  value,
  onChange,
  options,
  ariaLabel,
  className = '',
}) => (
  <div
    className={`icon-toggle-group ${className}`}
    role="radiogroup"
    aria-label={ariaLabel}
  >
    {options.map((opt) => {
      const Icon = opt.icon;
      const isActive = opt.value === value;
      const label = opt.ariaLabel || opt.value;
      return (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={isActive}
          aria-label={label}
          title={label}
          className={`icon-toggle-group__button${isActive ? ' icon-toggle-group__button--active' : ''}`}
          onClick={() => onChange?.(opt.value)}
        >
          <Icon size={20} weight="regular" aria-hidden="true" />
        </button>
      );
    })}
  </div>
);

export default IconToggleGroup;
